import React from 'react'

const FacebookFull = props => (
  <svg width={24} height={24} {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={24} height={24} fill={props.fill} rx={4} />
      <path
        fill="#fff"
        d="M13.05 18.306v-6.529h1.803l.239-2.25H13.05l.003-1.126c0-.587.056-.9.898-.9h1.127V5.25h-1.802c-2.165 0-2.927 1.091-2.927 2.927v1.35H9v2.25h1.35v6.529h2.7z"
      />
    </g>
  </svg>
)

export default FacebookFull
